import React from "react";
import { useTranslation } from "react-i18next";
import { Toast, ToastContainer } from "react-bootstrap";

interface ToastWarningProps {
    show: boolean;
    message: string;
    onClose: () => void;
}

const ToastWarning: React.FC<ToastWarningProps> = ({ show, message, onClose }) => {
    const { t } = useTranslation("common");
    return (
        <ToastContainer position="top-end" className="p-3">
            <Toast onClose={onClose} show={show} delay={3000} autohide>
                <Toast.Header>
                    <strong className="me-auto">{t("toast.error.title")}</strong>
                </Toast.Header>
                <Toast.Body>{message}</Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default ToastWarning;
